import React from "react";
import Button from "./Button";

const ButtonList = () => {
  return (
    <div className="hidden sm:flex">
      <Button />
    </div>
  );
};

export default ButtonList;
